import type { Account } from '@shared/products-types';

import { useSavingAccounts } from './useSavingAccounts';
import { useCurrentAccounts } from './useCurrentAccounts';
import type { useProducts } from './useProducts';

type HookReturnType = ReturnType<typeof useProducts<Account>>;

export const useCoreAccounts: () => HookReturnType = () => {
    const {
        isPending: isPendingCurrentAccounts,
        error: currentAccountsError,
        refetch,
        products: currentAccounts = [],
        productsById: currentAccountsById,
    } = useCurrentAccounts();
    const {
        isPending: isPendingSavingAccounts,
        error: savingAccountsError,
        products: savingAccounts = [],
        productsById: savingAccountsById,
    } = useSavingAccounts();

    return {
        isPending: isPendingCurrentAccounts || isPendingSavingAccounts,
        error: currentAccountsError || savingAccountsError,
        refetch,
        products: [...currentAccounts, ...savingAccounts],
        productsById: { ...currentAccountsById, ...savingAccountsById },
    };
};
